module.exports = __webpack_public_path__ + "img/CRC2_DC.04615a15.png";